// extracted by mini-css-extract-plugin
export default {"iconCheck":"styles-scoped__iconCheck--znqfo"};